<template>
  <div>
    <!-- Hide selector if the event is staff-led, which isn't supported for partnerships -->
    <partnership-field-base v-if="!isStaffLedCampaign" v-bind="$attrs" :label-for-single-option="labelForSingleOption" field="partnershipId" />
  </div>
</template>

<script>
import PartnershipFieldBase from '@/campaign-form-shared/partnership-field'
import { mapGetters, mapState } from 'vuex'

export default {
  components: { PartnershipFieldBase },

  computed: {
    ...mapGetters(['isStaffLedCampaign']),
    ...mapState(['partnershipOptions']),

    labelForSingleOption() {
      return this.i18n.t('events.form.single_association_option_hint', {associated_entity_name: this.partnershipOptions[0][0]})
    }
  }
}
</script>
